import React from "react";
import { Grid, Container, Typography, Button, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    minHeight: '50vh',
    padding: '2rem 0 0 0'
  },
  headerText: {
    fontFamily: 'DM Sans',
    color: '#fff',
    [theme.breakpoints.up('md')]: {
      fontSize: '2.2rem',
      fontWeight: '400',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.2rem',
      fontWeight: '400',
    },
  },
  subText: {
    fontFamily: 'DM Sans',
    color: '#fff',
    [theme.breakpoints.up('md')]: {
      fontSize: '0.9rem',
      fontWeight: '200',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem',
      fontWeight: '200',
    },
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '12rem'
    
  },
  input: {
    width: '70%',
    backgroundColor: '#fff',
    borderRadius: '2rem',
    height: '3.5rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 1rem 0 1rem'
  },
  link: {
    textDecoration: 'none',
    marginRight: '2rem',
    fontSize: '0.8rem',
    fontWeight: '300',
    color: '#fff',
    fontFamily: 'DM Sans'
  }
}))

const Footer = () => {
  const classes= useStyles()

  return (
    <Grid className={classes.container}>
      <Container>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={10} md={7}>
            <Typography align="center" className={classes.headerText}>
              Join our community & <span style={{textDecoration: 'underline'}}>stay updated</span>
            </Typography>
            <Typography align="center" className={classes.subText}>
              No spam. Only sweet content and update of our products.
            </Typography>
            <Grid className={classes.inputContainer}>
              <div className={classes.input}>
                <input style={{outline: 'none', border: 'none'}} placeholder="Email address" />
                <Button style={{backgroundColor: '#000', color: '#fff', borderRadius: '1rem', width: '4rem'}}>Submit</Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '4rem', marginTop: '4rem', borderTop: '1px solid rgba(255, 255, 255, 0.3)'}}>
        <Grid style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap'}}>
          <Link to="/about" className={classes.link}>About us</Link>
          <Link to="/contact" className={classes.link}>Contact us</Link>
          <a className={classes.link} href="https://www.facebook.com/tractracglobal">Facebook</a>
          <a className={classes.link} href="https://twitter.com/TractracGlobal">Twitter</a>
          <a className={classes.link} href="https://www.instagram.com/tractracglobal">Instagram</a>
        </Grid>
      </Container>
    </Grid>
  );
};

export default Footer;
